import {useTranslation} from '@/translations/i18n.tsx'
import {Helmet} from 'react-helmet'
import {Container} from '@components/ui/container'
import {PaymentsFilters} from '@features/payments/components/payments-filters'
import {PaymentsList} from '@features/payments/components/payments-list'

export const Payments = () => {
    const {t} = useTranslation()

    return (
        <Container className="grid grid-rows-[auto_auto_minmax(0,1fr)] gap-8 py-4 md:gap-8 md:pt-15 md:pb-6">
            <Helmet title={t('titles:transactions')} />
            <h1 className="text-display-sm font-medium">{t('admin:payments:title')}</h1>

            <PaymentsFilters />
            <PaymentsList />
            {/*<PaymentsRatingModal />*/}
        </Container>
    )
}
